module.exports = __webpack_public_path__ + "3d9e571ba0074306acd878d2e347e9bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-jungle.png
// module id = 3455
// module chunks = 0